import { Toast } from '@base-ui/react/toast';
import { cva, cx } from '@/cva.config';
import type { ToastType } from '@/hooks/useToast';

const toastVariants = cva({
  base: 'pointer-events-auto flex w-80 items-start gap-3 rounded-md border bg-surface p-3 text-sm lg:text-base shadow-lg transition-transform duration-200 data-ending-style:translate-x-2 data-starting-style:translate-x-2',
  variants: {
    type: {
      error: 'border-score-low text-score-low',
      info: 'border-border text-foreground',
      success: 'border-score-high text-score-high',
    },
  },
});

export const ToastList = () => {
  const { toasts } = Toast.useToastManager();

  return (
    <>
      {toasts.map((toast) => {
        const type = (toast.type ?? 'info') as ToastType;

        return (
          <Toast.Root
            className={cx(toastVariants({ type }))}
            key={toast.id}
            toast={toast}
          >
            <div className="flex-1">
              <Toast.Title className="font-medium">{toast.title}</Toast.Title>
              {toast.description && (
                <Toast.Description className="text-xs lg:text-sm text-foreground-muted">
                  {toast.description}
                </Toast.Description>
              )}
            </div>
            <Toast.Close className="text-foreground-muted hover:text-foreground">
              ×
            </Toast.Close>
          </Toast.Root>
        );
      })}
    </>
  );
};
